import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Dropdown } from 'components/shared/DesignSystem/Dropdown';
import TaskTypeCard from './TaskTypeCard';
import { ButtonCondensed } from '@companycam/slab-web';

const messages = defineMessages({
  newSubtask: {
    id: 'Project.taskList.subTasks.new',
    defaultMessage: 'Question',
    description: 'Button to open new subtask answer type dropdown menu',
  },
  taskTypeYesNo: {
    id: 'Project.taskList.subTasks.taskType.yesNo',
    defaultMessage: 'Yes/No',
    description: 'Yes/no answer type dropdown item',
  },
  taskTypeRatingScale: {
    id: 'Project.taskList.subTasks.taskType.ratingScale',
    defaultMessage: 'Rating',
    description: 'Rating scale answer type dropdown item',
  },
  taskTypeTextQuestion: {
    id: 'Project.taskList.subTasks.taskType.textQuestion',
    defaultMessage: 'Text',
    description: 'Text question answer type dropdown item',
  },
  taskTypeMultiSelect: {
    id: 'Project.taskList.subTasks.taskType.multiSelect',
    defaultMessage: 'Multiple Choice',
    description: 'Multi Select answer type dropdown item',
  },
  taskTypeYesNoDescription: {
    id: 'Project.taskList.subTasks.taskType.yesNo.description',
    defaultMessage: 'Ask for a "yes" or "no" answer',
    description: 'Yes/no answer type description',
  },
  taskTypeRatingScaleDescription: {
    id: 'Project.taskList.subTasks.taskType.ratingScale.description',
    defaultMessage: 'Ask for a 1-5 rating',
    description: 'Rating Scale answer type description',
  },
  taskTypeTextQuestionDescription: {
    id: 'Project.taskList.subTasks.taskType.textQuestion.description',
    defaultMessage: 'Ask for a text response',
    description: 'Text question answer type description',
  },
  taskTypeMultiSelectDescription: {
    id: 'Project.taskList.subTasks.taskType.multiSelect.description',
    defaultMessage: 'Ask a question with multiple answer choices',
    description: 'Multi-Select question answer type description',
  },
});

const DropdownWrapper = styled.div`
  width: 100%;
  margin-top: var(--cc_size_spacing_m);
  margin-left: var(--cc_size_spacing_xs);
`;

const NewSubtaskDropdown = ({ handleAddSubtask, taskId }) => {
  const { formatMessage } = useIntl();

  return (
    <DropdownWrapper>
      <Dropdown
        style={{ width: 320, zIndex: 100 }}
        triggerContent={
          <ButtonCondensed
            color="primary"
            icon={{
              name: 'plus',
              position: 'before',
            }}
            aria-label={formatMessage(messages.newSubtask)}
          >
            {formatMessage(messages.newSubtask)}
          </ButtonCondensed>
        }
      >
        {({ closeMenu }) => {
          const handleOnCardPress = async (subtaskType) => {
            await handleAddSubtask(subtaskType);
            closeMenu();
          };
          return (
            <>
              <TaskTypeCard
                handleOnCardPress={handleOnCardPress}
                taskId={taskId}
                title={formatMessage(messages.taskTypeYesNo)}
                type="yes_no"
                subtitle={formatMessage(messages.taskTypeYesNoDescription)}
                iconName="thumbs-up-down-outline"
              />
              <TaskTypeCard
                handleOnCardPress={handleOnCardPress}
                taskId={taskId}
                title={formatMessage(messages.taskTypeRatingScale)}
                type="rating"
                subtitle={formatMessage(
                  messages.taskTypeRatingScaleDescription,
                )}
                iconName="star-outline"
              />
              <TaskTypeCard
                handleOnCardPress={handleOnCardPress}
                taskId={taskId}
                title={formatMessage(messages.taskTypeTextQuestion)}
                type="open_text"
                subtitle={formatMessage(
                  messages.taskTypeTextQuestionDescription,
                )}
                iconName="text"
              />
              <TaskTypeCard
                handleOnCardPress={handleOnCardPress}
                taskId={taskId}
                title={formatMessage(messages.taskTypeMultiSelect)}
                type="multi_select"
                subtitle={formatMessage(
                  messages.taskTypeMultiSelectDescription,
                )}
                iconName="checkbox-marked-outline"
              />
            </>
          );
        }}
      </Dropdown>
    </DropdownWrapper>
  );
};

NewSubtaskDropdown.propTypes = {
  handleAddSubtask: PropTypes.func.isRequired,
  taskId: PropTypes.string,
};

export default NewSubtaskDropdown;
